:host {
  --font-family: var(--font-family-secondary);
}

:host {
  position: fixed;
  z-index: 99999;
  pointer-events: none;
  background-color: var(--grey-layout-501-neutral-background);
  color: var(--white-layout-300-primary);
  border-radius: var(--tooltip-border-radius, 4px);
  padding: var(--spacer) calc(var(--spacer) * 1.5);
  display: none;
  opacity: 0;
  height: auto;
  width: max-content;
  max-width: var(--tooltip-width);
  font-size: var(--tooltip-font-size);
  line-height: 21px;
  text-align: left;
  white-space: normal;
  word-break: break-word;
}

:host(.visible) {
  display: block;
  animation: 0.3s ease-out forwards;
  opacity: 1;
}

:host(.tooltip-error) {
  background-color: var(--red-layout-300-primary);
  color: var(--white-layout-300-primary);
}

:host(.tooltip-neutral) {
  background-color: var(--grey-layout-501-neutral-background);
  color: var(--white-layout-300-primary);
}

:host(.tooltip-warning) {
  background-color: var(--orange-layout-050-warning);
  color: var(--white-layout-300-primary);
}

:host(.tooltip-success) {
  background-color: var(--green-layout-100-primary-green);
  color: var(--white-layout-300-primary);
}

:host(.tooltip-informative) {
  background-color: var(--blue-layout-400-primary);
  color: var(--white-layout-300-primary);
}
